/*
 * @Author: ITDLCL
 * @Date: 2024-12-09 10:06:51
 * @LastEditors: LZT
 * @Description: pinia
 */
// getActivePinia 的问题需要提前挂载
import { createApp } from "vue";
import app from "../App.vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

const store = createPinia();
store.use(piniaPluginPersistedstate);

createApp(app).use(store);

export function setupStore (app) {
  app.use(store);
}
export default store;
